import { FormControl, FormGroup, Typography } from '@mui/material';
import React, { forwardRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import { CHECKLIST_PLANNER_PATH, SELECT_CHECKLIST_PATH } from '../../../../../utils/Constants';
import SelectStoreLocationIcon from '../../../../../asset/svg/SelectStoreLocationIcon.svg';
import '../../../../../scss/pages/Attendance/Component/Checklist/AddSchedule/AddSchedule.scss'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { POST_ADD_BULK_SCHEDULE, SAVE_CHECKLIST_DATE } from '../../../../../sagas/type';
import { getLocalStoreString } from '../../../../../utils/Helper';
import { useSnackbar } from 'notistack';

function AddSchedule() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { getChecklistData } = useSelector(mapStateToProps);
    const location = useLocation();
    const { selectStore } = location?.state;
    const [date, setDate] = useState('');
    const [dateChange, setDateChange] = useState([])
    const [validForm, setIsValidForm] = useState(false)

    useEffect(() => {
        if (getChecklistData && getChecklistData.length) {
            setDateChange(getChecklistData)
        }
    }, [])


    const handleBack = () => {
        navigate(SELECT_CHECKLIST_PATH, { state: { selectStore: selectStore } })
    }

    const handleUpdateAddSchedule = () => {
        const empCode = getLocalStoreString('EmployeeCode');
        const payloadData = dateChange?.filter((item) => item?.checked === true).map(item => ({ employeeCode: empCode, startDate: item?.startDate, endDate: item?.endDate, storeCode: selectStore?.storeCode, checklistName: item?.name }))
        dispatch({
            type: POST_ADD_BULK_SCHEDULE,
            payload: payloadData,
            navigate: navigate,
            enqueueSnackbar: enqueueSnackbar,
        })
    }

    const handleAddRemoveChecklist = () => {
        navigate(SELECT_CHECKLIST_PATH, { state: { selectStore: selectStore } })
    }
    const handleClearChecklistDate = (id) => {
        const chekclistArray = [...dateChange]
        const clearDate = chekclistArray?.map((item) => {
            if (item?.id === id) {
                const { date, ...rest } = item;
                return rest;
            }
            return item;
        })
        setDateChange(clearDate)
        dispatch({
            type: SAVE_CHECKLIST_DATE,
            payload: clearDate,
        })
    }

    const handleDateChange = (event, id) => {
        const chekclistArray = [...dateChange]
        const selectDate = moment(event).format('DD MMM yyyy');
        const selectedDate = moment(event).format('yyyy-MM-DD')
        const addDateChecklist = chekclistArray?.map((item) => {
            if (item?.id == id) {
                return { ...item, date: selectDate, startDate: selectedDate, endDate: selectedDate }
            }
            return item
        })
        setDateChange(addDateChecklist)
        setDate(selectDate)
        dispatch({
            type: SAVE_CHECKLIST_DATE,
            payload: addDateChecklist,
        })
    };

    useEffect(() => {
        const CheckedData = dateChange?.filter((item) => item?.checked === true)
        const isChecked = CheckedData?.every(obj => obj.hasOwnProperty('date'));
        setIsValidForm(isChecked)
    }, [dateChange])

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className='datepicker-custom-input-head'>
            <button className="datepicker-custom-input" onClick={onClick} ref={ref}>
                <CalendarMonthIcon sx={{ fontSize: "18px", color: "#8074FF" }} />
                <Typography sx={{ fontSize: "12px", color: "#8074FF", fontWeight: 600, paddingLeft: "2px" }}>Add </Typography>
            </button>
        </div>
    ));

    return (
        <div className='AddSchedule-Container' >
            <div className='AddSchedule-Container_header'>
                <div className='AddSchedule-Container_header_head-height'>
                    <img className='AddSchedule-Container_header_head-height_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='AddSchedule-Container_header_head-height_content'>Add Schedule</span>
                </div>
            </div>
            <div className='AddSchedule-Container_card-Parent-Container'>
                <div className="AddSchedule-Container_card-Parent-Container_storeName">
                    <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '14px', padding: 0 }}>Store Name</Typography>
                    <div className="AddSchedule-Container_card-Parent-Container_storeName_Location-text">
                        <img src={SelectStoreLocationIcon} />
                        <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", paddingLeft: "5px" }} value="name">{selectStore?.storeCode} - {selectStore?.storeName}</Typography>
                    </div>
                </div>
            </div>
            <div className='AddSchedule-Container_Checklist-Title'>
                <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '14px', lineHeight: '14px', padding: 0 }}>Checklist</Typography>
            </div>
            <div className="AddSchedule-Container_Checklist-items">
                {dateChange && dateChange?.length > 0 && dateChange?.filter((item) => item?.checked === true).map((item) => {
                    return (
                        <div key={item?.id} className='AddSchedule-Container_Checklist-items_card'>
                            <div className="AddSchedule-Container_Checklist-items_card_checklist">
                                <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', padding: "0.5rem", opacity: "0.5" }}> {item?.name}</Typography>
                            </div>
                            <div className="AddSchedule-Container_Checklist-items_card_AddDate">
                                <div className='AddSchedule-Container_Checklist-items_card_AddDate_dateBtn'>
                                    {item?.date ? <><Typography sx={{ fontSize: "12px", color: "#8074FF", fontWeight: 600, paddingLeft: "2px" }}>{item?.date}</Typography>
                                        <ClearRoundedIcon sx={{ color: 'rgba(255, 255, 255, 0.30)', width: "13px", height: "13px" }} onClick={() => handleClearChecklistDate(item?.id)} />
                                    </>

                                        : <ReactDatePicker
                                            onChange={(e) => handleDateChange(e, item?.id)}
                                            dateFormat="dd-MM-yyyy"
                                            minDate={new Date()}
                                            onBlur={() => setSelectedItemId(null)}
                                            customInput={<ExampleCustomInput />}
                                        />}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className='AddSchedule-Container_Download-button'>
                <div className='AddSchedule-Container_Download-button_btn-bottom'>
                    <div className='AddSchedule-Container_Download-button_btn-bottom_okbutton-container'>
                        <button disabled={!validForm} id='downloadBtn' className='AddSchedule-Container_Download-button_btn-bottom_okbutton-container_active-button' onClick={handleUpdateAddSchedule}>Update</button>
                        <Typography sx={{ fontSize: "12px", color: "#8074FF", fontWeight: 600, paddingLeft: "2px" }} onClick={handleAddRemoveChecklist}>Add / Remove Checklist</Typography>
                    </div>
                </div>
            </div>
        </div >
    )
} const mapStateToProps = (state) => {
    return {
        getChecklistData: state?.checklist?.getChecklist,
    }
}

export default AddSchedule